<template>
    <div class="my-page">
        <!-- 1. 用户信息及头像 -->
        <div v-if="userData.uid" class='my-page-info' :class="{'my-page-info-vip': parseInt(userVip) != 0}">
            <div class="my-base-info dsp-flex">
                <div class="my-base-info-box dsp-flex">
                    <div class="my-base-avatar-img">
                        <img v-bind:src="userData.avatar && userData.avatar != '' ? userData.avatar : 'https://m1.yxdxt.com/d.png'" alt="">
                        <div v-if="parseInt(userVip) != 0" class="avatar-crown"></div>
                        <div v-if="parseInt(userVip) != 0" class="avatar-vip"></div>
                        <div v-if="parseInt(userVip) == 0 && parseInt(userData.donate) == 1" class="avatar-donate"></div>
                    </div>
                    <div class="my-base-info-text">
                        <p class="my-base-nickname">{{userData.nickname}}</p>
                        <p class="my-base-sub-info"><span v-if="recordTotalData">八字保存数量：{{recordTotalData.length}}</span> (ID:{{userData.uid}})</p>
                    </div>
                </div>
                <!-- <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div> -->
            </div>
            <div class="my-vip-info" @click="clickMyVip">
                <!-- todo 内容动态变化 -->
                <div class="my-vip-info-text" v-if="parseInt(userVip) == 0">
                    <p class="text1">成为VIP你将享用更多的特权<span v-if="showVipReminder" class="red-circle"></span></p>
                    <p class="text2">你有1个VIP限时优惠待使用！</p>
                </div>
                <div class="my-vip-info-text" v-else>
                    <p class="text1">你是尊贵的{{parseInt(userVip) == 10 ? '月' : parseInt(userVip) == 20 ? '年' : '终身' }}VIP会员<span v-if="showVipReminder" class="red-circle"></span></p>
                    <p class="text2">点击查看你的特权</p>
                </div>
            </div>
        </div>
        <!-- 2. 中间功能列表通过设置 -->
        <div class="my-page-list-content">
            <div class="my-page-list">
                <!-- 1. 批量分享八字 -->
                <div v-if="VIEW_CONFIG.showShare" class="my-page-item dsp-flex" @click="clickBatchShare">
                    <div class="my-page-item-left"><i class="iconfont icon-share"></i>批量分享八字</div>
                    <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
                </div>
                <!-- 2. 批量接收八字 -->
                <div v-if="VIEW_CONFIG.showGet" class="my-page-item dsp-flex" @click="clickBatchGet">
                    <div class="my-page-item-left"><i class="iconfont icon-get"></i>批量接收八字</div>
                    <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
                </div>
                <!-- 3. 导出全部数据 -->
                <div v-if="VIEW_CONFIG.showExport" class="my-page-item dsp-flex" @click="clickBatchExport">
                    <div class="my-page-item-left"><i class="iconfont icon-export"></i>导出全部数据至文件</div>
                    <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
                </div>
            </div>
            <div class="my-page-list">
                <!-- 4. 对比记录 -->
                <div v-if="VIEW_CONFIG.showCompareList" class="my-page-item dsp-flex" @click="clickBatchCompare">
                    <div class="my-page-item-left"><i class="iconfont icon-compare2"></i>对比记录</div>
                    <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
                </div>
                <!-- 5. 课程中心 -->
                <div v-if="VIEW_CONFIG.showCourse" class="my-page-item dsp-flex" @click="clickBatchCourse">
                    <div class="my-page-item-left"><i class="iconfont icon-course"></i>课程中心</div>
                    <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
                </div>
            </div>
            <div class="my-page-list">
                <!-- 10、设置账号及密码 -->
                <div class="my-page-item dsp-flex" @click="clickSetTel">
                    <div class="my-page-item-left"><i class="iconfont icon-tel"></i>修改手机号</div>
                    <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
                </div>
                <div class="my-page-item dsp-flex" @click="clickSetPwd">
                    <div class="my-page-item-left"><i class="iconfont icon-pwd"></i>修改密码</div>
                    <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
                </div>
                <div class="my-page-item dsp-flex" @click="clickSetMyUI">
                    <div class="my-page-item-left"><i class="iconfont icon-ui"></i>命盘显示设置</div>
                    <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
                </div>
                <!-- 11、捐赠 -->
                <div v-if="VIEW_CONFIG.showDonate" class="my-page-item dsp-flex" @click="clickDonate">
                    <div class="my-page-item-left"><i class="iconfont icon-donate"></i>捐赠</div>
                    <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
                </div>
            </div>
        </div>
        <div class="my-page-list">
            <!-- 2、八字工具 -->
            <div v-if="VIEW_CONFIG.showTool" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-tool"></i>八字工具</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 3、生日提醒 -->
            <div v-if="VIEW_CONFIG.showBirth" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-birth"></i>生日提醒</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 4、批盘记录 -->
            <div v-if="VIEW_CONFIG.showPi" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-pi"></i>批盘记录</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 5、论盘记录 -->
            <div v-if="VIEW_CONFIG.showLun" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-lun-2"></i>论盘记录</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 6、对比记录 -->
            <div v-if="VIEW_CONFIG.showCompare" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-compare"></i>对比记录</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 7、我的数据报告 -->
            <div v-if="VIEW_CONFIG.showReport" class="my-page-item my-page-item-report dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-report"></i>我的数据报告</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 8、反馈中心 -->
            <div v-if="VIEW_CONFIG.showFeedback" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-feedback"></i>反馈中心</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            <!-- 9、关于天时子平八字 -->
            <div v-if="VIEW_CONFIG.showAbout" class="my-page-item dsp-flex">
                <div class="my-page-item-left"><i class="iconbg icon-about"></i>关于天时子平八字</div>
                <div class="my-page-more"><i class="iconfont icon-xiangyou"></i></div>
            </div>
            
        </div>
        <!-- 10. 按钮 -->
        <!-- <vip-ny-button></vip-ny-button> -->
        <!-- 3. 二级页面 -->
        <router-view></router-view>
    </div>
</template>

<script>
import { CONFIG } from '../../modules/config';
import { VIEW_CONFIG } from '../../modules/viewconfig'
import VipNyButton from '../../components/common/VipNyButton.vue'
import { MIX } from '../../modules/utils';
export default {
    name: 'My',
    components: { VipNyButton },
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        recordTotalData() {
            return this.$store.state.record.recordTotalData;
        },
        showVipReminder() {
            return this.$store.state.reminder.showVipReminder;
        }
    },
    data() {
        return {
            VIEW_CONFIG: VIEW_CONFIG,
            userVip: 0,
        }
    },
    mounted() {
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }
        this.$store.dispatch('initBasicData');
        this.userVip = this.$store.state.userData.info.vip;
        this.$bus.on('updateMyVipInfo', this.updateMyVipInfo);
        setTimeout(() => {
            this.initDom();
            MIX.trackPageViewed('Me');
        }, 20);
    },
    destroyed() {
        this.$bus.on('updateMyVipInfo', this.updateMyVipInfo);
    },
    methods: {
        initDom() {
            var height = innerHeight,
                infoDom = document.getElementsByClassName('my-page-info')[0],
                listDom = document.getElementsByClassName('my-page-list-content')[0];
            height = infoDom ? height-infoDom.clientHeight : height;
            if(listDom) {
                listDom.style.minHeight = (height-10)+'px';
            }
        },
        clickMyVip() {
            MIX.trackButtonClicked('me_vip');
            let userVip = this.$store.state.userData.info.vip;
            this.$store.dispatch('user/showMyVipPop', {vip: userVip, frompage: 'my'});
            var me = this;
            setTimeout(() => {
                me.$bus.emit('initMyVipPage');
                if(me.$store.state.user.curVipPayType == 3 || me.$store.state.user.curVipPayType == 4) {
                    me.$bus.emit('startMyVipAni');
                }
                me.$store.dispatch('reminder/udpateExtList', {
                    params: {'h5_vip_red': 1},
                    cb: function() {
                        me.$store.state.reminder.showVipReminder = false;
                    }
                });
            }, 20);
        },
        clickBatchShare() {
            MIX.trackButtonClicked('me_share_bz');
            this.$router.replace('/my/sendbzselect');
        },
        clickBatchGet() {
            MIX.trackButtonClicked('me_accept_bz');
            this.$router.replace('/my/getbz');
        },
        clickBatchExport() {
            MIX.trackButtonClicked('me_export_all_bz');
            this.$router.replace('/my/exportfile');
        },
        clickBatchCompare() {
            MIX.trackButtonClicked('me_compare_bz');
            this.$store.state.contrast.contrastFromPage = 'my';
            this.$router.replace('/contrastlist/my');
        },
        clickBatchCourse() {
            MIX.trackButtonClicked('me_course');
            this.$router.replace('/courselist/my');
        },
        clickSet() {
            this.$router.replace('/my/myset');
        },
        clickSetTel() {
            MIX.trackButtonClicked('me_account_password');
            this.$router.replace('/my/settel');
        },
        clickSetPwd() {
            MIX.trackButtonClicked('me_account_password');
            this.$router.replace('/my/setpwd');
        },
        clickSetMyUI() {
            this.$router.push({
                path: '/my/setui'
            });
        },
        clickDonate() {
            this.$router.replace('/donate/my');
        },
        updateMyVipInfo() {
            this.userVip = this.$store.state.userData.info.vip;
        }
    }
}
</script>